import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

export const ViewConfirmationState = {
	url: '/confirmation/:customerToken/:serviceProviderId/:consultationId/:proposalId',
	title: 'View Confirmation',
	params: {customerToken: null, serviceProviderId: null, consultationId: null, proposalId: null},
	// One state, one URL: the v2 provider flag decides which component renders. This state is
	// in publicStates, so getPresentationFlags reads the flag from the customer endpoint,
	// which needs the customerToken, serviceProviderId and consultationId already in the URL.
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<view-confirmation-v2></view-confirmation-v2>'
				: '<view-confirmation></view-confirmation>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return (
			RoutesSvc.getPresentationFlags({trans: $transition$})
				// a failed lookup imports the production page
				.catch(() => ({}))
				.then(flags =>
					flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
						? import(
								/* webpackChunkName: "viewConfirmationV2Mod" */
								'@Containers/view-confirmation-page/view-confirmation-v2.cmp.js'
							)
						: import(
								/* webpackChunkName: "confirmationPageMod" */
								'@Containers/view-confirmation-page/view-confirmation.cmp.js'
							)
				)
				.then(res => $ocLazyLoad.load({name: res.default}))
				.catch(err => $log.error(err))
		);
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPublic({status: 'accepted', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$', '$log'],
			// Swallowed rather than allowed to fail the transition, as on view.expired and
			// view.unavailable. The customer has just accepted: a dead transition here is the
			// worst possible moment to show them an error. An empty payload renders v1.
			resolveFn: (RoutesSvc, trans, $log) =>
				RoutesSvc.getPresentationFlags({trans}).catch(err => {
					$log.error('view.confirmation provider flags failed, falling back to v1:', err);
					return {};
				}),
		},
	],
};
